export default {
	// common locales
	"menu-management.grid-size": "Grid Size",
	"menu-management.button-size": "Button Style",
	"menu-management.button-size.legacy": "Legacy Button",
	"menu-management.button-size.modern": "Modern Button",
	"menu-management.columns": "Columns",
	"menu-management.all-brands": "ALL BRANDS",
	"menu-management.brand": "Brand",
	"menu-management.brand-id": "Brand ID: {id}",
	"menu-management.outlet": "Outlet",
	"menu-management.outlet-id": "Outlet ID: {id}",
	"menu-management.all-outlets": "All Outlets",
	"menu-management.terminal": "Terminal",
	"menu-management.terminal-id": "Terminal ID: {id}",
	"menu-management.terminal-no": "Terminal No.",
	"menu-management.all-terminals": "All Terminals",
	"menu-management.category": "Category",
	"menu-management.delete-category": "Delete Category",
	"menu-management.category.create.title": "Add New Category",
	"menu-management.category.edit.title": "Edit Category",
	"menu-management.category.delete.title": "This action cannot be undone!",
	"menu-management.category.delete.subtitle": 'Are you sure you want to delete "{name}" category?',
	"menu-management.export-category": "Export Category",
	"menu-management.categories": "Categories",
	"menu-management.import-categories": "Import Categories",
	"menu-management.sort-categories": "Sort Categories",
	"menu-management.category-id": "Category ID",
	"menu-management.category-name": "Category Name",
	"menu-management.category-name-alt": "Alt. Category Name",
	"menu-management.clone-category": "Clone Category",
	"menu-management.category.title.only-terminal": "This category is only visible at {name}.",
	"menu-management.category.title.outlet-brand": "This category is visible on all terminals at {name}.",
	"menu-management.category.title.all-brand": "This is a universal category. This category will be applied to all brands, outlets, and terminals.",
	"menu-management.category.default-accounting-code": "Default Accounting Code",
	"menu-management.category.hidden": "Hide on POS",
	"menu-management.clone": "Clone",
	"menu-management.publish": "Publish",
	"menu-management.publish-time": "Publish Time",
	"menu-management.publish-menu": "Publish Menu",
	"menu-management.publish-title": "When do you want to publish this menu category?",
	"menu-management.publish-last": "This menu was last published on {date}.",
	"menu-management.publish-scheduled": "This menu is currently scheduled to be published on {date}.",
	"menu-management.publish-time-now": "Immediately",
	"menu-management.publish-time-scheduled": "Scheduled",
	"menu-management.sort": "Sort Menu Items",
	"menu-management.sort-order": "Sort Order",
	"menu-management.menuitems": "Menu Items",
	"menu-management.menuitem": "Menu Item",
	"menu-management.menuitem-page-title": "Menu Item - ",
	"menu-management.menuitem-id": "Menu Item ID",
	"menu-management.menuitem.basic-info": "Basic Info",
	"menu-management.menuitem.image": "Image",
	"menu-management.menuitem.name": "Name",
	"menu-management.menuitem.name-alt": "Alt. Lang. Name",
	"menu-management.menuitem.name-short": "Receipt Name",
	"menu-management.menuitem.description": "Description",
	"menu-management.menuitem.accounting-info": "Accounting Info",
	"menu-management.menuitem.item-code": "Item Code",
	"menu-management.menuitem.accounting-code": "Accounting Code",
	"menu-management.menuitem.barcodes": "Barcodes",
	"menu-management.menuitem.pricing-info": "Pricing Info",
	"menu-management.menuitem.price-1": "In-Store Price",
	"menu-management.menuitem.price-2": "Grabfood Price",
	"menu-management.menuitem.price-3": "Foodpanda Price",
	"menu-management.menuitem.price-4": "Deliveroo Price",
	"menu-management.menuitem.price-takeaway": "Takeaway Add-On",
	"menu-management.menuitem.open-price": "Open Price",
	"menu-management.menuitem.open-price-enabled": "Open Pricing Enabled",
	"menu-management.menuitem.normal-price": "Normal Price",
	"menu-management.menuitem.display-info": "POS Display",
	"menu-management.menuitem.visible": "Visible",
	"menu-management.menuitem.hidden": "Hidden",
	"menu-management.menuitem.is-hidden": "Menu Item Hidden",
	"menu-management.menuitem.display-start": "Show From",
	"menu-management.menuitem.display-end": "Show To",
	"menu-management.menuitem.button-preview": "POS Preview",
	"menu-management.menuitem.button-color": "Button Colour",
	"menu-management.menuitem.button-text-color": "Text Colour",
	"menu-management.menuitem.barcode-info": "Barcodes",
	"menu-management.menuitem.kitchen-info": "Kitchen Display",
	"menu-management.menuitem.kitchen-group": "Kitchen Group",
	"menu-management.menuitem.kitchen-name": "Kitchen Receipt Name",
	"menu-management.menuitem.additional-info": "Additional Info",
	"menu-management.menuitem.quantity-selector": "Quantity Selector",
	"menu-management.menuitem.gst-taxable": "GST Taxable",
	"menu-management.menuitem.tax-exempt-notice": "This item is exempt from Taxes and Service Charges",
	"menu-management.menuitem.linked-items": "Linked Items",
	"menu-management.menuitem.linked-items.breadcrumb-all-brands": "ALL BRANDS",
	"menu-management.menuitem.linked-items.breadcrumb-terminal": "Terminal {n}",
	"menu-management.menuitem.linked-items.add": "Link Menu Item",
	"menu-management.menuitem.linked-items.add-linked": "+ Add",
	"menu-management.menuitem.linked-items.search-placeholder": "Search",
	"menu-management.menuitem.linked-items.search-empty": "No matching items",
	"menu-management.menuitem.linked-items.description": "Items linked here will be automatically added to the order when the main menu item is added to cart.",
	"menu-management.menuitem.linked-items.empty": "No linked items",
	"menu-management.menuitem.linked-items.modal-title": "Select Items to Link",
	"menu-management.menuitem.linked-items.modal-description": "Linked items will appear in the cart automatically. Use the list below to add them.",
	"menu-management.menuitem.linked-items.linked": "Linked",
	"menu-management.menuitem.linked-items.unlink": "Remove link",
	"menu-management.menuitem.linked-items.no-image-placeholder": "No image",
	"menu-management.menuitem.linked-items.quantity": "Quantity",
	"menu-management.menuitem.stock-keeping": "Stock Keeping",
	"menu-management.menuitem.sku-reference": "SKU Reference",
	"menu-management.menuitem.sku-quantity": "SKU QoM",
	"menu-management.menuitem.delete.title": "This action cannot be undone!",
	"menu-management.menuitem.delete.subtitle": "Are you sure you want to delete this menu item?",
	"menu-management.menuitem.clone": "Clone",
	"menu-management.menuitem.clone.title": "Clone - {name}",
	"menu-management.menuitem.clone.brand": "Brand Name",
	"menu-management.menuitem.clone.outlet": "Outlet Code",
	"menu-management.menuitem.clone.terminal-no": "Terminal No",
	"menu-management.menuitem.clone.category": "Menu Category",
	"menu-management.preview": "Preview",
	"menu-management.preview-grabfood": "GrabFood Preview",
	"menu-management.preview-foodpanda": "Foodpanda Preview",
	"menu-management.preview-deliveroo": "Deliveroo Preview",
	"menu-management.alt-language": "Switch Language",
	"menu-management.type": "Type",
	"menu-management.max-per-option": "Max Selections",
	"menu-management.bulk-edit.select-columns": "Select columns to display",
	"menu-management.bulk-edit.delete.title": "This action cannot be undone!",
	"menu-management.bulk-edit.delete.subtitle": 'Are you sure you want to delete {type} ID: {id} - {name}?',
	"menu-management.bulk-edit.publish.title": "Publish All Menus?",
	"menu-management.bulk-edit.publish.subtitle": "Are you sure you want to publish all menus for {name}?",

	// menu status locales
	"menu-management.status": "Status",
	"menu-management.status.sold-out": "Sold Out",
	"menu-management.reason": "Reason",
	"menu-management.expire-at": "Until",
	"menu-management.new-status": "New Status",
	"menu-management.all-outlets": "All Outlets",
	"menu-management.all-terminals": "All Terminals",
	"menu-management.status.create": "Create New Menu Status",
	"menu-management.status.edit": "Update Menu Status",
	"menu-management.reason": "Reason",
	"menu-management.scope": "Scope",
	"menu-management.scope.brand": "Entire Brand",
	"menu-management.scope.outlet": "Entire Outlet",
	"menu-management.scope.terminal": "Single Terminal",
	"menu-management.status.delete.title": "This action cannot be undone!",
	"menu-management.status.delete.subtitle": 'Are you sure you want to delete the "{status}" status for "{name}"?',

    // page titles
	"menu-management.status.page-description": "Update menu item availability by assigning temporary statuses.",
	"menu-management.bulk-edit.page-description": "This comprehensive view gives you centralized control over your menu's content and structure. Make fast, precise changes to all Categories, Menu Items, and Options using the table interface.",

	// placeholders / tooltips
	"menu-management.brand.placeholder": "Select a Brand",
	"menu-management.outlet.placeholder": "Select an Outlet",
	"menu-management.terminal.placeholder": "Select a Terminal",
	"menu-management.category.placeholder": "Select a Category",
	"menu-management.clone-category.placeholder": "Select a target brand, outlet, or terminal to clone this category to:",
	"menu-management.clone-menu-item.placeholder": "Select a target category to clone this menu item to:",
	"menu-management.menuitem.sku-reference.placeholder": "Select item from Inventory Catalog",
	"menu-management.menuitem.sku-quantity.placeholder": "Enter the Quantity of Measure",
	"menu-management.menuitem.item-code.tooltip": "The unique item code for statistics and reports",
	"menu-management.menuitem.accounting-code.tooltip": "The category to group by in statistics and reports",
	"menu-management.status.item-code.placeholder": "Search for any item code",
	"menu-management.status.placeholder": "Select a status",
	"menu-management.reason.placeholder": "Enter a reason",
	"menu-management.scope.placeholder": "Select a scope for this status",
	"menu-management.expire-at.placeholder": "Select a date and time",
	"menu-management.bulk-edit.search.placeholder": "Search for any category, menu item, or option",
	"menu-management.bulk-edit.column-selector.tooltip": "Select columns",
	"menu-management.bulk-edit.column-sort.tooltip": "Sort columns",
	"menu-management.bulk-edit.filter.tooltip": "Filter",
	"menu-management.bulk-edit.publish.tooltip": "Publish all menus for this brand, outlet, or terminal.",
	"menu-management.bulk-edit.batch-price-adjust": "Batch Adjust Prices",
	"menu-management.bulk-edit.batch-edit-attributes": "Batch Edit Attributes",
	"menu-management.bulk-edit.export-csv": "Export to CSV",
	"menu-management.bulk-edit.export-selected": "Export Selected",
	"menu-management.bulk-edit.filter-category": "Filter by Category",
	"menu-management.bulk-edit.filter-type": "Entity Type",
	"menu-management.bulk-edit.filter-status": "Status",
	"menu-management.bulk-edit.selected-count": "{count} item(s) selected",
	"menu-management.bulk-edit.clear-selection": "Clear Selection",

	// validation messages
    "menu-management.category.name.required": "What is the name of this category?",
	"menu-management.clone-category.brand.required": "Which brand to clone to?",
	"menu-management.clone-category.outlet.required": "Which outlet to clone to?",
	"menu-management.clone-category.terminal.required": "Which terminal to clone to?",
	"menu-management.clone-category.category.required": "Which category to clone to?",
    "menu-management.menuitem.name.required": "What is the name of this menu item?",
    "menu-management.menuitem.price-1.required": "What is the price of this menu item?",
    "menu-management.menuitem.accounting-code.required": "What is the accounting category for this menu item?",
    "menu-management.menuitem.item-code.required": "What is the item code for this menu item?",
    "menu-management.category.default-accounting-code.required": "What is the default accounting code for all menu items in this category?",
    "menu-management.category.default-accounting-code.pattern": "Only alphanumeric and - or _ are allowed.",
	"menu-management.status.item-code.required": "What is the item code?",
	"menu-management.status.required": "What is the status of this item?",
	"menu-management.scope.required": "What is the scope for this status?",
    "menu-management.item.name.required": "What is the name of this item?",
    "menu-management.item-option.max-per-option.required": "What is the maximum selections for this item?",
	"menu-management.category.terminal-no.required": "Which terminal does this category belong to?",
	"menu-management.category.sort-order.required": "What is the sorting number for this category?",

	// product catalog integration
	"menu-management.menuitem.catalog-locked": "Governed by Product Catalogue",
	"menu-management.menuitem.catalog-linked-title": "Linked to Product Catalogue",
	"menu-management.menuitem.catalog-linked-desc": "Name, Item Code, and Barcodes are centrally governed. Updates made in Product Catalogue will automatically propagate here.",
	"menu-management.menuitem.unbind-btn": "Unlink from Catalogue",
	"menu-management.menuitem.autonomous-title": "Locally Autonomous Item",
	"menu-management.menuitem.autonomous-desc": "This item is independent. You can edit all properties directly or link it to a Product Catalogue entry to standardize it across outlets.",
	"menu-management.menuitem.bind-btn": "Link to Product Catalogue",
	"menu-management.menuitem.bind.title": "Link to Product Catalogue?",
	"menu-management.menuitem.bind.content": "Linking this menu item to \"{name}\" ({code}) will synchronize its Name, Item Code, and Barcodes with the catalog. Local edits to these fields will be governed centrally. Continue?",
	"menu-management.menuitem.unbind.title": "Unlink from Product Catalogue?",
	"menu-management.menuitem.unbind.content": "Unlinking will make this menu item locally autonomous. You will be able to edit its name, item code, and barcodes directly for single-outlet customization.",
	"menu-management.menuitem.select-catalogue-title": "Select Product Catalogue Item",
}
